export default __webpack_public_path__ + "static/media/PC_v1_image@2x.c6689870.png";